import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Tailles et rayon du design system (src/index.css, tailwind.config.ts).
 * Sans cette déclaration, tailwind-merge prend `text-title` pour une COULEUR de
 * texte : `cn("text-title text-primary")` supprimerait l'une des deux classes.
 * Toute nouvelle taille ajoutée à la config doit être ajoutée ici.
 */
export const FONT_SIZE_TOKENS = [
  "micro",
  "label",
  "chip",
  "meta",
  "hint",
  "body",
  "tile",
  "title",
  "lead",
  "heading",
  "page",
  "kpi",
  "display",
  "stat",
  "stat-lead",
  "stat-hero",
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...FONT_SIZE_TOKENS] }],
      rounded: [{ rounded: ["control"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
